// AI写作模块路由配置
export const aiWriterMain = [
  {
    name: 'ai_writer',
    path: '/ai_writer',
    meta: {
      title: 'AI写作',
      icon: 'edit'
    }
  },
  {
    name: 'ai_writer_generate',
    path: '/ai_writer/generate',
    component: () => import('/@/views/plugins/ai_writer/index.vue'),
    meta: {
      title: '生成文章',
      icon: 'edit',
      plugin: 'ai_writer',
      keepAlive: true
    }
  },
  {
    name: 'ai_writer_articles',
    path: '/ai_writer/articles',
    component: () => import('/@/views/plugins/ai_writer/articles.vue'),
    meta: {
      title: '生成记录',
      icon: 'list',
      plugin: 'ai_writer'
    }
  }
]

export default aiWriterMain

